import React from "react";
import { getCategoriaPrimariaEN } from "../../portale/src/functions/functions";
import SvgIconDPC from "./dpc-svg-icon";

export default class DpcFormFiltri extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            searchQuery: "",
            searchDateInit: "",
            searchDateFine: "",
            searchAmbn: [],
            searchTerr: [],
            searchRisk: [],
            searchTPro: [],
            searchCtgr: [],
            searchSottodomini: [],
            searchContent: "Tutti"
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.filtra = this.filtra.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.text && prevProps.text !== this.props.text){
            this.setState({
                searchQuery: "",
                searchDateInit: "",
                searchDateFine: "",
                searchAmbn: [],
                searchTerr: [],
                searchRisk: [],
                searchTPro: [],
                searchCtgr: [],
                searchSottodomini: [],
                searchContent: "Tutti"
            });
            if (typeof document !== `undefined`) {
                ['searchCtgr', 'searchSottodomini'].forEach(item => {
                    var selEl = document.getElementById(item),
                        spnEl = document.querySelector(`#${item} + button .filter-option-inner-inner`),
                        lisEl = document.querySelectorAll(`#${item} + button + .dropdown-menu ul.inner li.selected`),
                        aslEl;
                    selEl.selectedIndex = "-1";
                    while (spnEl.firstChild) {
                        spnEl.removeChild(spnEl.firstChild);
                    }
                    spnEl.innerHTML = selEl.getAttribute("title");
                    for (var i = 0; i < lisEl.length; i++) {
                        lisEl[i].classList.remove("selected");
                        aslEl = lisEl[i].querySelector("a");
                        aslEl.classList.remove("selected");
                        aslEl.setAttribute("aria-selected", "false");
                    }
                })
            }
        }
    }

    handleInputChange(event){
        event.persist();
        this.setState((state) => {
            switch(event.target.name){
                case "searchAmbn":
                case "searchCtgr":
                case "searchSottodomini":
                case "searchTerr":
                case "searchRisk":
                case "searchTPro":
                    return {
                        [event.target.name]: Array.from(event.target.selectedOptions, option => option.value)
                    }
                default:
                    return {
                        [event.target.name]: event.target.value
                    };
            }
        });
    }

    filtra(event){
        event.persist();
        event.preventDefault();
        //Il datepicker di bootstrap non fa partire l'onChange di React (ovviamente)
        //e quindi le date vanno settate a mano al submit.
        this.setState({
            searchDateInit: document.getElementById("searchDateInit").value,
            searchDateFine: document.getElementById("searchDateFine").value
        }, () => {
            if(typeof this.props.filtra === "function")
                this.props.filtra(this.state);
            else console.warn("Non è stata predisposta una funzione filtra, quindi il il pulsante Applica non sortisce nessun effetto sulla view dei contenuti!")
        });
    }

    getCategoriaPrimariaEN(categoriaPrimaria) {
        if(categoriaPrimaria !== ""){
            switch(categoriaPrimaria){
                case "comunicato_stampa":
                    return "press release";
                case "notizia":
                    return "news";
                case "approfondimento":
                    return "supplementary worksheet";
                case "pubblicazione":
                    return "publication";
                case "corsi":
                    return "courses";
                case "pagina":
                    return "page";
                case "galleria_foto":
                case "galleria_flickr":
                    return "photo";
                case "video":
                    return "video";
                case "bando_di_gara":
                    return "call for tender";
                case "mappa":
                    return "map";
                case "timeline":
                    return "timeline";
                default:
                    return "";
            }
        }
        return "";
    }

    getSottodominiEN(sottodominio) {
        if(sottodominio !== ""){
            switch(sottodominio.toUpperCase()){
                case "EMERGENZE":
                    return "EMERGENCIES";
                case "SERVIZIO NAZIONALE":
                    return "NATIONAL SERVICE";
                case "RISCHI":
                    return "RISKS";
                case "VOLONTARIATO":
                    return "VOLUNTEERING";
                case "DOMANDE E RISPOSTE":
                    return "Q&A";
                case "RELAZIONI INTERNAZIONALI":
                    return "INTERNATIONAL RELATIONS";
                case "CAPRISCHIO 21-27":
                    return "CAPRISCHIO 21-27";
                case "FORMAZIONE":
                    return "TRAINING";
                case "EVENTI":
                    return "EVENTS";
                case "MAPPE":
                    return "MAPS";
                default:
                    return "";
            }
        }
        return "";
    }

    render(){
        return (
            <div className="px-custom">
                <div className="search-btn-and-form-tab">
                    <button className="btn btn-primary search-form-tab-toggle" type="button" id="searchFormTabToggle"
                            aria-haspopup="true" aria-expanded="false">
                        <span>{this.props.lang === 'it' ? "Filtra" : "Filter"}</span>
                        <SvgIconDPC name='expand' color='white' classiAggiuntive={"icon-expand icon-sm icon-light"}/>
                    </button>
                    <div className="search-form-tab-custom d-none">
                        <form id="searchForm" role="search" onSubmit={this.filtra}>
                            <div className="row">
                                <div className="col-md-6">
                                    {!(!!this.props.fullText) &&
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text">
                                                    <SvgIconDPC name='search' classiAggiuntive={'icon-sm'}/>
                                                </div>
                                            </div>
                                            <label htmlFor="searchQuery">{this.props.lang === 'it' ? "Inserisci parola chiave" : "Enter keyword"}</label>
                                            <input type="text" className="form-control" id="searchQuery"
                                                   name="searchQuery" value={this.state.searchQuery}
                                                   onChange={this.handleInputChange}/>
                                        </div>
                                    </div>
                                    }
                                    <div className="it-datepicker-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <label htmlFor="searchDateInit">{this.props.lang === 'it' ? "Inserisci data inizio GG/MM/AAAA" : "Enter start date DD/MM/YYYY"}</label>
                                                <input type="text" className="form-control it-date-datepicker"
                                                       id="searchDateInit" name="searchDateInit"
                                                       value={this.state.searchDateInit}
                                                       onChange={this.handleInputChange}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="it-datepicker-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <label htmlFor="searchDateFine">{this.props.lang === 'it' ? "Inserisci data fine GG/MM/AAAA" : "Enter end date DD/MM/YYYY"}</label>
                                                <input type="text" className="form-control it-date-datepicker"
                                                       id="searchDateFine" name="searchDateFine"
                                                       value={this.state.searchDateFine}
                                                       onChange={this.handleInputChange}/>
                                            </div>
                                        </div>
                                    </div>

                                    {Array.isArray(this.props.tipiProvvedimenti) &&
                                    <div className="bootstrap-select-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <SvgIconDPC name='funnel' classiAggiuntive={'icon-sm'}/>
                                                    </div>
                                                </div>
                                                <label htmlFor="searchTPro" className="sr-only">{this.props.lang === 'it' ? "Tipo provvedimento" : "Type of provision"}</label>
                                                <select id="searchTPro" name="searchTPro" data-multiple-separator=""
                                                        title={this.props.lang === 'it' ? "Tipo provvedimento" : "Type of provision"} multiple={true}
                                                        value={this.state.searchTPro}
                                                        onChange={this.handleInputChange}>
                                                    {this.props.tipiProvvedimenti.map(item => {
                                                        if(!item.children.length){
                                                            return (
                                                                <option label={item.title} id={item.id}
                                                                        value={item.id}
                                                                        data-content={`<span class='select-pill'><span class='select-pill-text'>${item.title}</span></span>`}/>
                                                            )
                                                        } else{
                                                            return (
                                                                <optgroup label={item.title}>
                                                                    {item.children.map(element => {
                                                                        return (
                                                                            <option label={element.title}
                                                                                    id={element.id}
                                                                                    value={element.id}
                                                                                    data-content={`<span class='select-pill'><span class='select-pill-text'>${element.title}</span></span>`}/>
                                                                        )
                                                                    })}
                                                                </optgroup>
                                                            )
                                                        }
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                <div className="col-md-6">
                                    {this.props.ambiti &&
                                    <div className="bootstrap-select-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <SvgIconDPC name='funnel' classiAggiuntive={'icon-sm'}/>
                                                    </div>
                                                </div>
                                                <label htmlFor="searchAmbn" className="sr-only">{this.props.lang === 'it' ? "Ambito" : "Scope"}</label>
                                                <select id="searchAmbn" name="searchAmbn" data-multiple-separator=""
                                                        title={this.props.lang === 'it' ? "Ambito" : "Scope"} multiple={true} value={this.state.searchAmbn}
                                                        onChange={this.handleInputChange}>
                                                    {this.props.ambiti.map(item => {
                                                        if(!item.children.length){
                                                            return (
                                                                <option label={item.title} id={item.id}
                                                                        value={item.id}
                                                                        data-content={`<span class='select-pill'><span class='select-pill-text'>${item.title}</span></span>`}/>
                                                            )
                                                        } else{
                                                            return (
                                                                <optgroup label={item.title}>
                                                                    {item.children.map(element => {
                                                                        return (
                                                                            <option label={element.title}
                                                                                    id={element.id}
                                                                                    value={element.id}
                                                                                    data-content={`<span class='select-pill'><span class='select-pill-text'>${element.title}</span></span>`}/>
                                                                        )
                                                                    })}
                                                                </optgroup>
                                                            )
                                                        }
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {this.props.territori &&
                                    <div className="bootstrap-select-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <SvgIconDPC name='funnel' classiAggiuntive={'icon-sm'}/>
                                                    </div>
                                                </div>
                                                <label htmlFor="searchTerr" className="sr-only">{this.props.lang === 'it' ? "Territorio" : "Territory"}</label>
                                                <select id="searchTerr" name="searchTerr" data-multiple-separator=""
                                                        title={this.props.lang === 'it' ? "Territorio" : "Territory"} multiple={true} value={this.state.searchTerr}
                                                        onChange={this.handleInputChange}>
                                                    {this.props.territori.map(item => {
                                                        if(!item.children.length){
                                                            return (
                                                                <option label={item.title} id={item.id}
                                                                        value={item.id}
                                                                        data-content={`<span class='select-pill'><span class='select-pill-text'>${item.title}</span></span>`}/>
                                                            )
                                                        } else{
                                                            return (
                                                                <optgroup label={item.title}>
                                                                    {item.children.map(element => {
                                                                        return (
                                                                            <option label={element.title}
                                                                                    id={element.id}
                                                                                    value={element.id}
                                                                                    data-content={`<span class='select-pill'><span class='select-pill-text'>${element.title}</span></span>`}/>
                                                                        )
                                                                    })}
                                                                </optgroup>
                                                            )
                                                        }
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {this.props.rischi &&
                                    <div className="bootstrap-select-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <SvgIconDPC name='funnel' classiAggiuntive={'icon-sm'}/>
                                                    </div>
                                                </div>
                                                <label htmlFor="searchRisk" className="sr-only">{this.props.lang === 'it' ? "Rischio" : "Risk"}</label>
                                                <select id="searchRisk" name="searchRisk" data-multiple-separator=""
                                                        title={this.props.lang === 'it' ? "Rischio" : "Risk"} multiple value={this.state.searchRisk}
                                                        onChange={this.handleInputChange}>
                                                    {this.props.rischi.map(item => {
                                                        if(!item.children.length){
                                                            return (
                                                                <option label={item.title} id={item.id}
                                                                        value={item.id}
                                                                        data-content={`<span class='select-pill'><span class='select-pill-text'>${item.title}</span></span>`}/>
                                                            )
                                                        } else{
                                                            return (
                                                                <optgroup label={item.title}>
                                                                    {item.children.map(element => {
                                                                        return (
                                                                            <option label={element.title}
                                                                                    id={element.id}
                                                                                    value={element.id}
                                                                                    data-content={`<span class='select-pill'><span class='select-pill-text'>${element.title}</span></span>`}/>
                                                                        )
                                                                    })}
                                                                </optgroup>
                                                            )
                                                        }
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {this.props.categorie &&
                                    <div className="bootstrap-select-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <SvgIconDPC name='funnel' classiAggiuntive={'icon-sm'}/>
                                                    </div>
                                                </div>

                                                <label htmlFor="searchCtgr" className="sr-only">{this.props.lang === 'it' ? "Categoria" : "Category"}</label>
                                                <select id="searchCtgr" name="searchCtgr" data-multiple-separator=""
                                                        title={this.props.lang === 'it' ? "Categoria" : "Category"} multiple value={this.state.searchCtgr}
                                                        onChange={this.handleInputChange}>
                                                    {this.props.categorie.map(item => {
                                                        return (
                                                            <option label={this.props.lang === 'it' ? item.replace(/_/g, ' ') : getCategoriaPrimariaEN(item).replace(/_/g, ' ')} id={item}
                                                                    value={item.toLowerCase().replace(/ /g,"_")}
                                                                    data-content={`<span class='select-pill'><span class='select-pill-text'>${item.replace(/_/g, ' ')}</span></span>`}/>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {this.props.sottodomini &&
                                    <div className="bootstrap-select-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <SvgIconDPC name='funnel' classiAggiuntive={'icon-sm'}/>
                                                    </div>
                                                </div>
                                                <label htmlFor="searchSottodomini" className="sr-only">{this.props.lang === 'it' ? "Aree tematiche" : "Thematic areas"}</label>
                                                <select id="searchSottodomini" name="searchSottodomini"
                                                        data-multiple-separator=""
                                                        title={this.props.lang === 'it' ? "Aree tematiche" : "Thematic areas"} multiple
                                                        value={this.state.searchSottodomini}
                                                        onChange={this.handleInputChange}>
                                                    {this.props.sottodomini.map(item => {
                                                        return (
                                                            <option label={this.props.lang === 'it' ? item : this.getSottodominiEN(item)} id={item}
                                                                    value={item.toLowerCase().replace(/ /g,"_")}
                                                                    data-content={`<span class='select-pill'><span class='select-pill-text'>${item}</span></span>`}/>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {
                                        this.props.contenutiTestuali === true &&
                                        <fieldset>
                                            <legend className="sr-only">
                                            {this.props.lang === 'it' ? "Tipo di contenuti testuali o multimediali da selezionare" : "Type of text or multimedia content to select"}
                                                
                                            </legend>
                                            <div className="form-group">
                                                <div className="form-check form-check-inline">
                                                    <input type="radio" id="searchNewsComs" name="searchContent"
                                                           value="Tutti"
                                                           checked={this.state.searchContent === "Tutti"}
                                                           onChange={this.handleInputChange}/>
                                                    <label htmlFor="searchNewsComs">{this.props.lang === 'it' ? "Tutti" : "All"}</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input type="radio" id="searchNews" name="searchContent"
                                                           value="Solo notizie"
                                                           checked={this.state.searchContent === "Solo notizie"}
                                                           onChange={this.handleInputChange}/>
                                                    <label htmlFor="searchNews">{this.props.lang === 'it' ? "Solo notizie" : "News only"}</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input type="radio" id="searchComs" name="searchContent"
                                                           value="Solo comunicati stampa"
                                                           checked={this.state.searchContent === "Solo comunicati stampa"}
                                                           onChange={this.handleInputChange}/>
                                                    <label htmlFor="searchComs">{this.props.lang === 'it' ? "Solo comunicati stampa" : "Press releases only"}</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    }
                                    {this.props.corsiFormazione === true &&
                                    <fieldset>
                                        <legend className="sr-only">{this.props.lang === 'it' ? "Categoria corso formazione da cercare" : "Training course category to search for"}
                                        </legend>
                                        <div className="form-group">
                                            <div className="form-check form-check-inline">
                                                <input type="radio" id="searchFotoVideo" name="searchContent"
                                                       value="Tutti"
                                                       checked={this.state.searchContent === "Tutti"}
                                                       onChange={this.handleInputChange}/>
                                                <label htmlFor="searchFotoVideo">{this.props.lang === 'it' ? "Tutti" : "All"}</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input type="radio" id="searchOnln" name="searchContent"
                                                       value="On line"
                                                       checked={this.state.searchContent === "On line"}
                                                       onChange={this.handleInputChange}/>
                                                <label htmlFor="searchOnln">Online</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input type="radio" id="searchPres" name="searchContent"
                                                       value="In presenza"
                                                       checked={this.state.searchContent === "In presenza"}
                                                       onChange={this.handleInputChange}/>
                                                <label htmlFor="searchPres">{this.props.lang === 'it' ? "In presenza" : "In attendance"}</label>
                                            </div>
                                        </div>
                                    </fieldset>
                                    }
                                    {this.props.contenutiMultimediali === true &&
                                    <fieldset>
                                        <legend className="sr-only">{this.props.lang === 'it' ? "Tipo di contenuti multimediali da cercare" : "Type of media to search for"}
                                        </legend>
                                        <div className="form-group">
                                            <div className="form-check form-check-inline">
                                                <input type="radio" id="searchFotoVideo" name="searchContent"
                                                       value="Tutti"
                                                       checked={this.state.searchContent === "Tutti"}
                                                       onChange={this.handleInputChange}/>
                                                <label htmlFor="searchFotoVideo">{this.props.lang === 'it' ? "Tutti" : "All"}</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input type="radio" id="searchFoto" name="searchContent"
                                                       value="Solo foto"
                                                       checked={this.state.searchContent === "Solo foto"}
                                                       onChange={this.handleInputChange}/>
                                                <label htmlFor="searchFoto">{this.props.lang === 'it' ? "Solo Foto" : "Photos only"}</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input type="radio" id="searchVideo" name="searchContent"
                                                       value="Solo video"
                                                       checked={this.state.searchContent === "Solo video"}
                                                       onChange={this.handleInputChange}/>
                                                <label htmlFor="searchVideo">{this.props.lang === 'it' ? "Solo Video" : "Videos only"}</label>
                                            </div>
                                        </div>
                                    </fieldset>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group float-right">
                                        <button type="submit" id="searchSubmit" className="btn btn-primary">{this.props.lang === 'it' ? "Applica" : "Apply"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
